import React, { useEffect, useContext, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import AppContext from '../../App/AppContext';
import { Link, useHistory } from 'react-router-dom';
import { Avatar, Card, CardContent, Typography, Container, makeStyles, Tooltip } from '@material-ui/core';
import '../Auditor/Dashboard/dashboard.scss';
import { getDashboardForInvoice } from '../../Core/Service/InvoiceScreen-service';
import EmailIcon from '@material-ui/icons/Email';
import DescriptionIcon from '@material-ui/icons/Description';
import PeopleIcon from '@material-ui/icons/People';
import { getCustomerDashboard } from '../../Core/Service/customer-services';
import { getCommunicatorDash } from '../../Core/Service/CustUserCommunicator/communicator-service';
import { AppStorage } from './../../Core/Service/storage-service';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import DriveEtaIcon from '@material-ui/icons/DriveEta';
import TimerIcon from '@material-ui/icons/Timer';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import DateRangeIcon from '@material-ui/icons/DateRange';
import MessageIcon from '@material-ui/icons/Message';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import LiveHelpIcon from '@material-ui/icons/LiveHelp';
import AnnouncementIcon from '@material-ui/icons/Announcement';
import ForumIcon from '@material-ui/icons/Forum';
import TelegramIcon from '@material-ui/icons/Telegram';
import CheckIcon from '@material-ui/icons/Check';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import LibraryAddCheckIcon from '@material-ui/icons/LibraryAddCheck';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import DepartureBoardIcon from '@material-ui/icons/DepartureBoard';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        border: '2px solid rgb(90 114 123 / 20%)',
        Opacity: 0.9,
        minWidth: 345,
        borderRadius: 15,
        boxShadow: 'rgb(90 114 123 / 11%) 0px 7px 30px 0px',
        paddingBottom: 20
    },

    avatar: {
        height: 40,
        width: 40
    }
}));

export const RenderTiles = (props) => {
    const classes = useStyles();
    const { cards, label } = props;
    let history = useHistory();

    let onChange = (val) => {
        history.push(val);
    };

    return (
        <div>
            <Card className={classes.root}>
                <Typography variant="h5" style={{ background: 'white', color: 'black', padding: 20, textAlign: 'center' }}>
                    {props.label}
                </Typography>

                <Grid container style={{ background: 'white' }} justify="flex-start" spacing={2}>
                    {cards?.map((m, i) => {
                        let Icons = m.icon;
                        return (
                            <Tooltip title={m.name} arrow key={`card${i}`}>
                                <Grid item xs={12} md={6} xl={3}>
                                    <div
                                        style={{
                                            width: '100%',
                                            display: 'flex',
                                            padding: '10px'
                                            // border: '1px solid rgb(90 114 123 / 4%)'
                                        }}
                                    >
                                        <div style={{ width: '6%' }}></div>
                                        <div style={{ width: '16%', marginTop: 5 }}>
                                            <Avatar
                                                aria-label="recipe"
                                                className={classes.avatar}
                                                style={{ backgroundColor: m.color, boxShadow: ` 0px 0px 0px 8px ${m?.color}` }}
                                            >
                                                {Icons}
                                            </Avatar>
                                        </div>

                                        <div
                                            style={{
                                                // marginLeft: 10,
                                                width: '80%',
                                                cursor: m?.url ? 'pointer' : 'auto',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                                width: '50%',
                                                overflow: 'hidden',
                                                textAlign: 'left'
                                                // paddingBottom: 17
                                            }}
                                            onClick={() => onChange(m?.url)}
                                        >
                                            <div style={{ fontSize: 17, marginBottom: 0, fontWeight: 530 }}> {m?.name}</div>

                                            <span style={{ fontSize: 26, fontWeight: 600 }}> {m?.count}</span>
                                        </div>
                                    </div>
                                </Grid>
                            </Tooltip>
                        );
                    })}
                </Grid>
            </Card>
        </div>
    );
};
const CustCommonDash = (props) => {
    const portalSettings = AppStorage.getPortalSetting();
    let menuPermissionCounter = AppStorage.menuPermissionCounter();
    const [state, setState] = useState({
        InvoiceData: [],
        eWIPData: [],
        communicatorData: []
    });
    const { showToast } = useContext(AppContext);

    useEffect(async () => {
        if (AppStorage.getWIPAllowed() && portalSettings.portalSettingeWIPEnabled) {
            let res2 = await getCustomerDashboard();
            if (res2.success) {
                setState((st) => ({ ...st, eWIPData: res2.data }));
            }
            if (!res2.success) {
                showToast(res2.message);
            }
        }

        if (AppStorage.getInvoiceAllowed()) {
            let res = await getDashboardForInvoice();
            if (res.success) {
                setState((st) => ({ ...st, InvoiceData: res.data.list[0] }));
            } else {
                showToast(res.message);
            }
        }

        if (AppStorage.getCommunicatorAllowed()) {
            let communicator = await getCommunicatorDash();
            if (communicator.success) {
                setState((st) => ({ ...st, communicatorData: communicator.data?.list[0] }));
            }
            if (!communicator.success) {
                showToast(communicator.message);
            }
        }
    }, []);
    const InvoiceMember = [
        {
            id: 1,
            name: 'All Invoices',
            color: '#1abc9c',
            count: state.InvoiceData.allInvoices || 0,
            icon: <ForumIcon />,
            url: '/invoice/allInvoices'
        },
        {
            id: 2,
            name: 'Invoices Outstanding',
            color: '#e74c3c',
            count: state.InvoiceData.unPaidInvoices || 0,
            icon: <AnnouncementIcon />,
            url: '/invoice/Invoice_Outstanding'
        },
        {
            id: 3,
            name: 'Invoices Queried',
            color: '#ff9f00',
            count: state.InvoiceData.queriedCount || 0,
            icon: <LiveHelpIcon />,
            url: '/invoice/Invoice_Queried'
        },
        {
            id: 4,
            name: 'Invoices Paid',
            color: '#1abc9c',
            count: state.InvoiceData.paidInvoices || 0,
            icon: <DoneAllIcon />,
            url: '/invoice/Invoice_Paid'
        },
        {
            id: 5,
            name: 'Messages Sent',
            color: '#95a5a6',
            count: state.InvoiceData.messagesSent || 0,
            icon: <TelegramIcon />,
            url: '/invoice/messagesSent'
        },
        {
            id: 5,
            name: 'Messages Received',
            color: '#9b6bcc',
            count: state.InvoiceData.messagesReceived || 0,
            icon: <EmailIcon />,
            url: '/invoice/messagesReceived'
        }
        // {
        //     id: 5,
        //     name: 'Total Customer',
        //     color: '#2ecc71',
        //     count: state.InvoiceData.customerCount || 0,
        //     icon: <PeopleIcon />,
        //     url: '/invoice/Customers'
        // }
    ];
    const eWIPDataMember = [
        {
            id: 1,
            name: 'Current Month',
            color: '#3498db',
            icon: <DateRangeIcon />,
            count: state.eWIPData.currentMonth,
            url: '/Customer/Current Month/1'
        },
        {
            id: 2,
            name: 'Current Year',
            color: '#2ecc71',
            icon: <CalendarTodayIcon />,
            count: state.eWIPData.currentYear,
            url: '/Customer/Current Year/2'
        },
        {
            id: 3,
            name: 'Last Year',
            color: '#dc3545',
            icon: <CalendarTodayIcon />,
            count: state.eWIPData.preYear,
            url: '/Customer/Last Year/3'
        },
        {
            id: 4,
            name: 'Total',
            color: '#868e96',
            icon: <DescriptionIcon />,
            count: state.eWIPData.total,
            url: '/Customer/Total/4'
        }
    ];

    const CommunicatorMember = [
        {
            id: 1,
            name: 'Awaiting Authority',
            color: '#3498db',
            icon: <TimerIcon />,
            count: state.communicatorData.awaitingAuthorityCount,
            url: '/AwaitingAuthority'
        },
        {
            id: 2,
            name: 'Site Vehicles',
            color: '#2ecc71',
            icon: <DriveEtaIcon />,
            count: state.communicatorData.siteVehiclesCount,
            url: '/SiteVehicles'
        },
        {
            id: 3,
            name: 'VOR Vehicles',
            color: '#dc3545',
            icon: <LocalShippingIcon />,
            count: state.communicatorData.vorVehiclesCount,
            url: '/VORVehicles'
        }
    ];

    let permissionCounterCustList = [
        {
            id: 1,
            name: 'VOR Vehicles',
            color: '#dc3545',
            icon: <LocalShippingIcon />,
            count: state.communicatorData.vorVehiclesCount,
            url: { pathname: '/SiteVehicles', search: `?status=VOR` }
        },
        // {
        //     id: 4,
        //     name: 'Awaiting Full Order',
        //     color: '#dc3545',
        //     icon: <ShoppingCartIcon />,
        //     count: state.communicatorData.awaitingFullOrderNumberCount,
        //     url: { pathname: '/SiteVehicles', search: `?status=AFON` }
        // },
        {
            id: 13,
            name: 'Site Vehicles',
            color: '#3498db',
            icon: <DriveEtaIcon />,
            count: state.communicatorData.siteVehiclesCount,
            url: { pathname: '/SiteVehicles', search: `?status=S` }
        },
        {
            id: 17,
            name: 'Work Completed',
            color: '#2ecc71',
            icon: <LibraryAddCheckIcon />,
            count: state.communicatorData.workCompletedCount,
            url: { pathname: '/SiteVehicles', search: `?status=WC` }
        },
        {
            id: 18,
            name: ' Awaiting Collection',
            color: '#2ecc71',
            icon: <DepartureBoardIcon />,
            count: state.communicatorData.awaitingCollectionCount,
            url: { pathname: '/SiteVehicles', search: `?status=ACOLLECTION` }
        }
    ];

    return (
        <div style={{ margin: 10 }}>
            <Grid
                container
                spacing={1}
                direction="row"
                // justify="space-between"
                alignItems="center"
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
            >
                {AppStorage.getWIPAllowed() && portalSettings.portalSettingeWIPEnabled ? (
                    <Grid item xs={12} style={{ padding: '6px 8px' }}>
                        <RenderTiles cards={eWIPDataMember} label="eWIP" />
                    </Grid>
                ) : null}
                {AppStorage.getInvoiceAllowed() && (
                    <Grid item xs={12} style={{ padding: '6px 8px' }}>
                        <RenderTiles cards={InvoiceMember} label="Invoices" />
                    </Grid>
                )}
                {AppStorage.getCommunicatorAllowed() && (
                    <Grid item xs={12} style={{ padding: '6px 8px' }}>
                        <RenderTiles cards={menuPermissionCounter == 1 ? permissionCounterCustList : CommunicatorMember} label="Communicator" />
                    </Grid>
                )}
            </Grid>
        </div>
    );
};
export default CustCommonDash;
